import { ContactList } from "@nova/schemas"
import { useState } from "react"

export const useInviteEverywhereModalState = () => {
    const [mode, setMode] = useState<string>("Email")
    const [csvFile, setCsvFile] = useState<File[] | undefined>()
    const [emails, setEmails] = useState<string[]>([])
    const [emailInput, setEmailInput] = useState<string>("")
    const [selectedContactLists, setSelectedContactLists] = useState<ContactList[]>([])

    return {
        mode,
        setMode,
        csvFile,
        setCsvFile,
        emails,
        setEmails,
        emailInput,
        setEmailInput,
        selectedContactLists,
        setSelectedContactLists,
    }
}
